// React
import React, { useState } from "react";
import { useParams } from "react-router-dom";

// Components
import ContactContainer from "../components/ContactContainer";
import ListCreatorModal from "../components/ListCreatorModal"; // TODO? Person, not List
import PeopleSideBar from "../components/PeopleSideBar";

// EventifyAPI
import * as EventifyAPI from "../libs/EventifyAPI";

export default function ContactsPage(appProps) {
  let { personid } = useParams();

  const [isPersonCreatorModalOpen, setIsPersonCreatorModalOpen] = useState(false);

  return (
    <div className="contacts-page">
      <PeopleSideBar
        email={appProps.email}
        organizationid={appProps.organizationid}
        createNewPersonAction={() => {setIsPersonCreatorModalOpen(true);}}
      />

      <ContactContainer
        personid={personid}
      />

      <ListCreatorModal
        visible={isPersonCreatorModalOpen}
        onCancel={() => {setIsPersonCreatorModalOpen(false);}}
        email={appProps.email}
      />
    </div>
  );
}
